/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable indent */
/* eslint-disable linebreak-style */
import PropTypes from 'prop-types';
import React, { useCallback, useState, useEffect } from 'react';
import NavLink from 'components/NavLink';
import get from 'base-ui/dist/underline/get';
import Image from 'components/Image';
import { useDispatch } from 'react-redux';
import PostCardAdInfo from 'components/PostCardAdInfo';
import { addBookmark, deleteBookmark } from '../../state/slices/bookmarks';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const GridPostItem = ({ post, lazy, big, isAuthenticated, bookmarks, handleBookmarks }) => {
  const category = post.categories ? post.categories[0] : post.category;
  const thumbnail = get(post, 'featured_media.medium_large', '/images/no-image_medium.png');
  const permalink = post.permalink || `/${post.slug}/`;
  const [isBookmark, setIsBookmark] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const result = bookmarks.find((item) => item === post.id);
    setIsBookmark(result !== undefined);
  }, [bookmarks, post]);

  const handleBookmarkClick = useCallback((e) => {
    e.preventDefault();
    if (isBookmark === false) {
      dispatch(addBookmark(post));
      handleBookmarks([...bookmarks, post.id]);
    } else if (isBookmark === true) {
      dispatch(deleteBookmark(post.id));
      handleBookmarks(bookmarks.filter((item) => item !== post.id));
    }
  }, [bookmarks, isBookmark, post]);

  return (
    <article className="content-post news">
      <NavLink
        basePath={publicRuntimeConfig.PUBLIC_URL}
        as={`${permalink}`}
        to={`/article?permalink=${post.permalink}`}
        routerStrategy={'next'}
      >
        <div className="thumb">
          {
            isAuthenticated && (
            <span className="favorite" onClick={handleBookmarkClick}>
              {isBookmark ? (
                <i className="fas fa-bookmark"></i>
              ) : (
                <i className="far fa-bookmark"></i>
              )}
            </span>)
          }
          <div
            className="thumb-wrap"
          >
            <Image
              className="thumb-bg"
              src={thumbnail}
              srcSet={`${big ? get(post, 'featured_media.medium', '/images/no-image_medium.png') : get(post, 'featured_media.big-size_mobile', '/images/no-image_medium.png')} 425w,
                    ${get(post, 'featured_media.medium_large', '/images/no-image_big.png')} 768w,
                    ${get(post, 'featured_media.large', '/images/no-image_big.png')} 1024w`}
              width={520}
              height={325}
              alt={post.title}
              loading="lazy"
              layout="responsive"
              lazy={lazy}
            >
              <div style={{ height: '100%', width: '100%', background: '#ccc no-repeat center center' }}></div>
            </Image>
          </div>
        </div>
        <div className="caption">
          <div className="metas">
            <span className="meta cat text-uppercase main-color">
              {category && category.name}
            </span>
          </div>
          <h2
            className="title"
            dangerouslySetInnerHTML={{
              __html: post.title
            }}
          />
          {post?.sponsor && (
            <PostCardAdInfo
              logo={post?.sponsor?.logo}
              bgColor={post?.sponsor?.background}
              borderColor={post?.sponsor?.color}
              fontColor={post?.sponsor?.color}
              clientName={post?.sponsor?.brand}
              adType={post?.sponsor?.type}
            />
          )}
        </div>
      </NavLink>
    </article>
  );
};

GridPostItem.defaultProps = {
  post: {
    title: '',
    slug: '',
    permalink: '',
    categories: [],
  },
  lazy: false,
  isAuthenticated: false,
  bookmarks: [],
};

GridPostItem.propTypes = {
  post: PropTypes.object,
  lazy: PropTypes.bool,
  big: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  bookmarks: PropTypes.array,
  handleBookmarks: PropTypes.func
};

export default GridPostItem;
